if (typeof window !== 'undefined') {
  require('xtend-library/src/core/drop/drop.js')
  require('xtend-library/src/core/form/form.js')
  require('xtend-library/src/core/overlay/overlay.js')
  require('xtend-library/src/core/toggle/toggle.js')
}
